// NewTopic.tsx

import React, { useState } from 'react';
import {
  withStyles,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  WithStyles,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ValidationService from '../../services/authentication/ValidationService';
import ApiRoutes from '../../services/ApiRoutes';
import API from '../../services/ApiInstance';
import InfoDialog from '../dialog/InfoDialog';
import { toast } from 'react-toastify';

const styles = {
  button: {
    borderRadius: 8,
  },
  control: {
    marginBottom: '1em',
  },
};

const FORM_ERROR_TEXT =
  'The form could not be submitted - please fill all the required fields.';

interface NewTopicProps extends WithStyles<typeof styles> {
  onSuccess: () => void;
}

const NewTopic: React.FC<NewTopicProps> = ({
  onSuccess,
  classes,
}) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [validationErrorText, setValidationErrorText] = useState('');
  const [openValidationError, setOpenValidationError] = useState(false);
  const [loading, setLoading] = useState(false);
  const validator = new ValidationService();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setName('');
  };

  const submit = () => {
    const requirements = [
      ValidationService.validators.required(name),
    ];
    
    const isValid = validator.validate(...requirements);

    if (!isValid) {
      setValidationErrorText(FORM_ERROR_TEXT);
      setOpenValidationError(true);
    } else {
      setLoading(true);
      const newTopic = { name };

      API.post(ApiRoutes.addTopic, newTopic)
        .then(() => {
          setLoading(false);
          handleClose();
          onSuccess();
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err);
          handleClose();
        });
    }
  };

  return (
    <>
      <Button
        color="primary"
        variant="contained"
        onClick={handleClickOpen}
        className={classes.button}
      >
        <AddIcon />
        Add new topic
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle>New Topic</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            required
            autoFocus
            fullWidth
            variant="outlined"
            className={classes.control}
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={submit}
            disabled={loading}
            variant="contained"
          >
            Create
          </Button>
          <Button onClick={handleClose} color="primary" variant="outlined">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      {openValidationError && (
        <InfoDialog
          open={openValidationError}
          onClose={() => setOpenValidationError(false)}
          text={validationErrorText}
        />
      )}
    </>
  );
};

export default withStyles(styles)(NewTopic);
